/* eslint-disable react/prop-types */
import React from 'react';
import {
  Button,
  ButtonGroup,
  DrawerBody,
  DrawerFooter,
  Alert
} from '@one-thd/sui-atomic-components';

const SignInDrawer = ({ onClose }) => {

  const currentPathname = window?.location?.pathname;

  const getSignInRedirectUrl = () => {
    return `/auth/view/signin?redirect=${currentPathname ?? '/'}`;
  };

  return (
    <>
      <DrawerBody>
        <Alert status="info">
          Please Sign In to Add to Quote
        </Alert>
      </DrawerBody>
      <DrawerFooter>
        <ButtonGroup orientation="vertical">
          <Button
            fullWidth
            variant="primary"
            href={getSignInRedirectUrl()}
          >
            Sign In
          </Button>
          <Button
            fullWidth
            variant="secondary"
            onClick={onClose}
          >
            Cancel
          </Button>
        </ButtonGroup>
      </DrawerFooter>
    </>
  );
};

SignInDrawer.propTypes = {};

SignInDrawer.displayName = 'SignInDrawer';

export { SignInDrawer };